import { Toast } from "primereact/toast";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import "./style.scss";

const ToastMessage = forwardRef((props, ref, position = "bottom-right") => {
  const toast = useRef(null);

  useImperativeHandle(ref, () => ({
    show({
      severity = "info",
      summary = "",
      detail = "",
      life = 3000,
      icon,
      otherAction = "",
      handleOtherAction = () => {},
    }) {
      toast.current.show([
        {
          severity,
          summary,
          detail,
          life,
          content: (
            <div className="flex align-items-center gap-2">
              {icon && <i className={`${icon} text-lg`} />}
              <div className="flex">
                <span className="summary">
                  {summary} <span className="description">{detail}</span>{" "}
                  {otherAction && (
                    <span className="other__action" onClick={handleOtherAction}>
                      {otherAction}
                    </span>
                  )}
                </span>
              </div>
            </div>
          ),
        },
      ]);
    },
    clear() {
      toast.current.clear();
    },
  }));

  return <Toast className="toaster_message" ref={toast} position={position} />;
});

export default ToastMessage;
